import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=45ccece2&"
var script = {}
import style0 from "./Preloader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports